import { Injectable } from '@angular/core';
import { BindUserGQL } from '../data-services/graphql';

@Injectable({
  providedIn: 'root',
})
export class TrackUserService {

  constructor(
    private bindUserGQL: BindUserGQL,
  ) { }

  public bindUser() {
    return this.bindUserGQL.mutate().toPromise();
  }
}
